export default __webpack_public_path__ + "static/media/hatchy.b6e3fcab.mp4";